// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply(0)
        .call();
      let isPublicSaleEnabled = await store
        .getState()
        .blockchain.smartContract.methods.isPublicSaleEnabled()
        .call();
      let nowPhasePs = await store
        .getState()
        .blockchain.smartContract.methods.nowPhasePs()
        .call();
      let fcfsPhase = await store
        .getState()
        .blockchain.smartContract.methods.getPhaseIds(0)
        .call();

      dispatch(
        fetchDataSuccess({
          totalSupply,
          isPublicSaleEnabled,
          nowPhasePs,
          fcfsPhase,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
